import {computed} from 'vue'
import {CATEGORIES, SALES_AREA, REGION_KEYS} from '~/assets/js/constants'
import {useUserStore} from '@/store/user'
import {useAuthStore} from '@/store/auth'
import useI18nExtended from '~/composables/usei18nExtended'
import HeroImage from '~/assets/images/Teaser_O_R_Ing_Calculator_Imagemotiv_Produktgruppen_links_1500x263.jpg'
import CortecoHeroImage from '~/assets/images/Corteco_Main_Cut.png'
import FNLubeBannerImage from '~/assets/images/Banner_EASY_1500x263.jpg'

export const useHomeHero = () => {
  const nuxtApp = useNuxtApp()
  const i18n = useI18nExtended()
  const region = nuxtApp.$globalization.getRegion()
  const userStore = useUserStore()
  const authStore = useAuthStore()
  const config = useRuntimeConfig()

  const isCortecoUser = computed(() => {
    if (!authStore.userObject || !userStore.loggedIn) {
      return false
    }
    const selectedCustomer = userStore.selectedCustomer as any
    if (!selectedCustomer || !selectedCustomer.salesOrg) {
      return false
    }
    const salesArea = `${selectedCustomer.salesOrg}-${selectedCustomer.salesChannel}-${selectedCustomer.distribution}`
    return salesArea === SALES_AREA.Corteco
  })

  const isPromotionEnabled = computed(() => config.public.ENABLE_PROMOTION_HERO === '1')
  const isNARegion = computed(() => region === REGION_KEYS.NA)
  const showFNLubeBanner = computed(() => isPromotionEnabled.value && isNARegion.value && !isCortecoUser.value)

  const heroSection = computed(() => {
    if (showFNLubeBanner.value) {
      return {
        Image: {
          url: FNLubeBannerImage,
          width: 1500,
          height: 263
        },
        Header: i18n.tv('fnLubeHeadline', 'home'),
        Link: nuxtApp.$globalization.localePath(CATEGORIES.FNLubePage),
        ButtonLabel: i18n.tv('fnLubeButton', 'home'),
        SecondaryLink: nuxtApp.$globalization.localePath(CATEGORIES.RootCategoriesUrl),
        SecondaryButtonLabel: i18n.tv('showAllProducts', 'home'),
        isFNLubeBanner: true,
        IsNonEnglish: i18n.locale.value !== 'en',
        TextAppearance: 'Light',
        FSTwave: false
      }
    }

    if (isCortecoUser.value) {
      return {
        Image: {
          url: CortecoHeroImage,
          width: 1500,
          height: 263
        },
        Header: i18n.tv('cortecoHeadline', 'home'),
        Link: nuxtApp.$globalization.localePath(CATEGORIES.RootCategoriesUrl),
        TextAppearance: 'Light',
        ButtonLabel: i18n.tv('showAllProducts', 'home'),
        LeftText: i18n.tv('cortecoLeftText', 'home')
      }
    }

    return {
      Image: {
        url: HeroImage,
        width: 1500,
        height: 263
      },
      Header: i18n.tv('headline', 'home'),
      Link: nuxtApp.$globalization.localePath(CATEGORIES.RootCategoriesUrl),
      TextAppearance: 'Light',
      ButtonLabel: i18n.tv('showAllProducts', 'home'),
      LeftText: null
    }
  })

  return {
    isCortecoUser,
    heroSection
  }
}
